import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || location.pathname !== '/'
          ? 'bg-background-50/95 backdrop-blur-md border-b border-secondary-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className={`ri-book-read-line text-2xl ${isScrolled || location.pathname !== '/' ? 'text-primary-500' : 'text-background-50'}`}></i>
            </div>
            <span className={`text-xl font-bold font-heading whitespace-nowrap transition-colors ${
              isScrolled || location.pathname !== '/' ? 'text-foreground-900' : 'text-background-50'
            }`}>
              韩漫网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                location.pathname === '/'
                  ? isScrolled
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50/20 text-background-50'
                  : isScrolled
                    ? 'text-foreground-700 hover:text-foreground-900 hover:bg-secondary-100'
                    : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/romance"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                location.pathname.startsWith('/category')
                  ? isScrolled
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50/20 text-background-50'
                  : isScrolled
                    ? 'text-foreground-700 hover:text-foreground-900 hover:bg-secondary-100'
                    : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                location.pathname === '/about'
                  ? isScrolled
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50/20 text-background-50'
                  : isScrolled
                    ? 'text-foreground-700 hover:text-foreground-900 hover:bg-secondary-100'
                    : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className={`pl-10 pr-4 py-2 rounded-full text-sm border transition-all duration-200 w-48 focus:w-64 focus:outline-none focus:ring-2 focus:ring-primary-300 ${
                  isScrolled || location.pathname !== '/'
                    ? 'bg-background-100 border-secondary-200 text-foreground-900 placeholder-foreground-400'
                    : 'bg-background-50/15 border-background-50/20 text-background-50 placeholder-background-50/50'
                }`}
              />
              <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                <i className={`ri-search-line text-sm ${isScrolled || location.pathname !== '/' ? 'text-foreground-400' : 'text-background-50/60'}`}></i>
              </div>
            </div>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              isScrolled || location.pathname !== '/' ? 'text-foreground-900 hover:bg-secondary-100' : 'text-background-50 hover:bg-background-50/10'
            }`}
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-secondary-200/60 px-4 py-4 space-y-2">
          <Link to="/" className="block px-4 py-3 rounded-lg text-foreground-900 font-medium hover:bg-secondary-100 transition-colors whitespace-nowrap">首页</Link>
          <Link to="/category/romance" className="block px-4 py-3 rounded-lg text-foreground-700 font-medium hover:bg-secondary-100 transition-colors whitespace-nowrap">分类浏览</Link>
          <Link to="/about" className="block px-4 py-3 rounded-lg text-foreground-700 font-medium hover:bg-secondary-100 transition-colors whitespace-nowrap">关于我们</Link>
          <div className="relative px-4 pt-2">
            <input
              type="text"
              placeholder="搜索漫画..."
              className="w-full pl-10 pr-4 py-3 rounded-full text-sm border border-secondary-200 bg-background-100 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300"
            />
            <div className="absolute left-7 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
              <i className="ri-search-line text-sm text-foreground-400"></i>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}